
import { Record, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { option_type, record_type, array_type, string_type, int32_type, union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { PrimaryT, VerilogInput_$reflection, IdentifierT_$reflection } from "./VerilogTypes.js";
import { strToIntCheckWidth } from "../Simulator/NumberHelpers.js";
import { concat, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { toInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { parse, op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { int32ToString, Exception } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { defaultArg, value as value_7 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { fold, initialize, concat as concat_1, map, append } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { ofArray, choose, append as append_1, singleton, fold as fold_1 } from "../fable_modules/fable-library-js.5.13.0/List.js";

export class ModuleDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ModuleOld", "ModuleNew"];
    }
    static ModuleOld = new ModuleDU(0, []);
    static ModuleNew = new ModuleDU(1, []);
}

export function ModuleDU_$reflection() {
    return union_type("VerilogAST.ModuleDU", [], ModuleDU, () => [[], []]);
}

export class BaseDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Binary", "Decimal", "Hex"];
    }
    static Binary = new BaseDU(0, []);
    static Decimal = new BaseDU(1, []);
    static Hex = new BaseDU(2, []);
}

export function BaseDU_$reflection() {
    return union_type("VerilogAST.BaseDU", [], BaseDU, () => [[], [], []]);
}

export class Number$ extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All", "Unsigned"];
    }
}

export function Number$_$reflection() {
    return union_type("VerilogAST.Number", [], Number$, () => [[["bits", int32_type], ["num_base", BaseDU_$reflection()], ["allnumber", string_type], ["location", int32_type]], [["unsignednumber", int32_type], ["location", int32_type]]]);
}

export class OperatorDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Lor", "Land", "OrOp", "Xor", "Xnor", "AndOp", "Nand", "Nor", "Eq", "Neq", "Lt", "Lte", "Gt", "Gte", "Plus", "Minus", "Mult", "Sll", "Srl", "Sra", "NotOp"];
    }
    static Lor = new OperatorDU(0, []);
    static Land = new OperatorDU(1, []);
    static OrOp = new OperatorDU(2, []);
    static Xor = new OperatorDU(3, []);
    static Xnor = new OperatorDU(4, []);
    static AndOp = new OperatorDU(5, []);
    static Nand = new OperatorDU(6, []);
    static Nor = new OperatorDU(7, []);
    static Eq = new OperatorDU(8, []);
    static Neq = new OperatorDU(9, []);
    static Lt = new OperatorDU(10, []);
    static Lte = new OperatorDU(11, []);
    static Gt = new OperatorDU(12, []);
    static Gte = new OperatorDU(13, []);
    static Plus = new OperatorDU(14, []);
    static Minus = new OperatorDU(15, []);
    static Mult = new OperatorDU(16, []);
    static Sll = new OperatorDU(17, []);
    static Srl = new OperatorDU(18, []);
    static Sra = new OperatorDU(19, []);
    static NotOp = new OperatorDU(20, []);
}

export function OperatorDU_$reflection() {
    return union_type("VerilogAST.OperatorDU", [], OperatorDU, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class SelectDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PlusWidth", "MinusWidth"];
    }
    static PlusWidth = new SelectDU(0, []);
    static MinusWidth = new SelectDU(1, []);
}

export function SelectDU_$reflection() {
    return union_type("VerilogAST.SelectDU", [], SelectDU, () => [[], []]);
}

export class PrimaryDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Identifier", "IdentifierBit", "IdentifierBits", "VariableBitSelect", "IdentifierBitsSelect", "IdentifierArray", "VariableArrayBitSel"];
    }
}

export function PrimaryDU_$reflection() {
    return union_type("VerilogAST.PrimaryDU", [], PrimaryDU, () => [[["Item", IdentifierT_$reflection()]], [["id", IdentifierT_$reflection()], ["index", int32_type]], [["id", IdentifierT_$reflection()], ["start", int32_type], ["end_", int32_type]], [["id", IdentifierT_$reflection()], ["index", ExpressionDU_$reflection()]], [["id", IdentifierT_$reflection()], ["start", ExpressionDU_$reflection()], ["width", int32_type], ["select", SelectDU_$reflection()]], [["id", IdentifierT_$reflection()], ["indices", array_type(ArraySelect_$reflection())], ["start", int32_type], ["end_", int32_type]], [["id", IdentifierT_$reflection()], ["indices", array_type(ArraySelect_$reflection())], ["index", ExpressionDU_$reflection()]]]);
}

export class ArraySelect extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConstArraySelect", "VarArraySelect"];
    }
}

export function ArraySelect_$reflection() {
    return union_type("VerilogAST.ArraySelect", [], ArraySelect, () => [[["Item", int32_type]], [["Item", ExpressionDU_$reflection()]]]);
}

export class ExpressionDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LogicalOr", "LogicalAnd", "BitwiseOr", "BitwiseXor", "BitwiseXnor", "BitwiseAnd", "Equality", "Comparison", "ShiftExpr", "Additive", "Multiplicative", "Reduction", "Negation", "Unary", "UnaryUnsigned", "ConditionalOp"];
    }
}

export function ExpressionDU_$reflection() {
    return union_type("VerilogAST.ExpressionDU", [], ExpressionDU, () => [[["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", ExpressionDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()], ["Item3", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()], ["Item3", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()], ["Item3", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()], ["Item3", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()], ["Item3", ExpressionDU_$reflection()]], [["Item1", OperatorDU_$reflection()], ["Item2", ExpressionDU_$reflection()]], [["Item", UnaryDU_$reflection()]], [["Item", UnaryDU_$reflection()]], [["Item", Number$_$reflection()]], [["cond", ExpressionDU_$reflection()], ["ifTrue", ExpressionDU_$reflection()], ["ifFalse", ExpressionDU_$reflection()]]]);
}

export class UnaryDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Primary", "Number", "Parenthesis", "Concat", "ParamNumber"];
    }
}

export function UnaryDU_$reflection() {
    return union_type("VerilogAST.UnaryDU", [], UnaryDU, () => [[["Item", PrimaryDU_$reflection()]], [["Item", Number$_$reflection()]], [["Item", ExpressionDU_$reflection()]], [["Item", array_type(ExpressionDU_$reflection())]], [["Item1", PrimaryDU_$reflection()], ["bits", string_type]]]);
}

export class AssignDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Blocking", "NonBlocking", "WireAssign"];
    }
    static Blocking = new AssignDU(0, []);
    static NonBlocking = new AssignDU(1, []);
    static WireAssign = new AssignDU(2, []);
}

export function AssignDU_$reflection() {
    return union_type("VerilogAST.AssignDU", [], AssignDU, () => [[], [], []]);
}

export class Assignment extends Record {
    constructor(Type, LHS, RHS) {
        super();
        this.Type = Type;
        this.LHS = LHS;
        this.RHS = RHS;
    }
}

export function Assignment_$reflection() {
    return record_type("VerilogAST.Assignment", [], Assignment, () => [["Type", AssignDU_$reflection()], ["LHS", AssignmentLHS_$reflection()], ["RHS", ExpressionDU_$reflection()]]);
}

export class AssignmentLHS extends Record {
    constructor(PrimaryType, VariableBitSelect) {
        super();
        this.PrimaryType = PrimaryType;
        this.VariableBitSelect = VariableBitSelect;
    }
}

export function AssignmentLHS_$reflection() {
    return record_type("VerilogAST.AssignmentLHS", [], AssignmentLHS, () => [["PrimaryType", PrimaryDU_$reflection()], ["VariableBitSelect", option_type(ExpressionDU_$reflection())]]);
}

export class StatementDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NonBlockingAssign", "BlockingAssign", "SeqBlock", "Case", "Conditional", "ForStatement"];
    }
}

export function StatementDU_$reflection() {
    return union_type("VerilogAST.StatementDU", [], StatementDU, () => [[["Item1", Assignment_$reflection()], ["location", int32_type]], [["Item1", Assignment_$reflection()], ["location", int32_type]], [["Item1", array_type(StatementDU_$reflection())], ["location", int32_type]], [["Item1", CaseStatement_$reflection()], ["location", int32_type]], [["ifstmt", IfStatement_$reflection()], ["elseStmt", option_type(StatementDU_$reflection())], ["location", int32_type]], [["Item1", ForStatement_$reflection()], ["location", int32_type]]]);
}

export class IfStatement extends Record {
    constructor(Condition, Statement, Location) {
        super();
        this.Condition = Condition;
        this.Statement = Statement;
        this.Location = (Location | 0);
    }
}

export function IfStatement_$reflection() {
    return record_type("VerilogAST.IfStatement", [], IfStatement, () => [["Condition", ExpressionDU_$reflection()], ["Statement", StatementDU_$reflection()], ["Location", int32_type]]);
}

export class CaseStatement extends Record {
    constructor(Expression, CaseItems, Default, Location) {
        super();
        this.Expression = Expression;
        this.CaseItems = CaseItems;
        this.Default = Default;
        this.Location = (Location | 0);
    }
}

export function CaseStatement_$reflection() {
    return record_type("VerilogAST.CaseStatement", [], CaseStatement, () => [["Expression", ExpressionDU_$reflection()], ["CaseItems", array_type(CaseItem_$reflection())], ["Default", option_type(StatementDU_$reflection())], ["Location", int32_type]]);
}

export class CaseItem extends Record {
    constructor(Expressions, Statement) {
        super();
        this.Expressions = Expressions;
        this.Statement = Statement;
    }
}

export function CaseItem_$reflection() {
    return record_type("VerilogAST.CaseItem", [], CaseItem, () => [["Expressions", array_type(Number$_$reflection())], ["Statement", StatementDU_$reflection()]]);
}

export class ForStatement extends Record {
    constructor(Initialisation, Condition, Step, Statement, Location) {
        super();
        this.Initialisation = Initialisation;
        this.Condition = Condition;
        this.Step = Step;
        this.Statement = Statement;
        this.Location = (Location | 0);
    }
}

export function ForStatement_$reflection() {
    return record_type("VerilogAST.ForStatement", [], ForStatement, () => [["Initialisation", Assignment_$reflection()], ["Condition", ExpressionDU_$reflection()], ["Step", Assignment_$reflection()], ["Statement", StatementDU_$reflection()], ["Location", int32_type]]);
}

export class Range$ extends Record {
    constructor(Start, End, Location) {
        super();
        this.Start = Start;
        this.End = End;
        this.Location = (Location | 0);
    }
}

export function Range$_$reflection() {
    return record_type("VerilogAST.Range", [], Range$, () => [["Start", ExpressionDU_$reflection()], ["End", ExpressionDU_$reflection()], ["Location", int32_type]]);
}

export class DeclarationDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InputDecl", "OutputDecl", "LogicDecl", "ParameterDecl"];
    }
    static InputDecl = new DeclarationDU(0, []);
    static OutputDecl = new DeclarationDU(1, []);
    static LogicDecl = new DeclarationDU(2, []);
    static ParameterDecl = new DeclarationDU(3, []);
}

export function DeclarationDU_$reflection() {
    return union_type("VerilogAST.DeclarationDU", [], DeclarationDU, () => [[], [], [], []]);
}

export class DataTypeDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["WireType", "Bit"];
    }
    static WireType = new DataTypeDU(0, []);
    static Bit = new DataTypeDU(1, []);
}

export function DataTypeDU_$reflection() {
    return union_type("VerilogAST.DataTypeDU", [], DataTypeDU, () => [[], []]);
}

export class Declaration extends Record {
    constructor(DeclarationType, DataType, Range$, ArrayRanges, Variables, Location) {
        super();
        this.DeclarationType = DeclarationType;
        this.DataType = DataType;
        this.Range = Range$;
        this.ArrayRanges = ArrayRanges;
        this.Variables = Variables;
        this.Location = (Location | 0);
    }
}

export function Declaration_$reflection() {
    return record_type("VerilogAST.Declaration", [], Declaration, () => [["DeclarationType", DeclarationDU_$reflection()], ["DataType", DataTypeDU_$reflection()], ["Range", option_type(Range$_$reflection())], ["ArrayRanges", option_type(array_type(Range$_$reflection()))], ["Variables", array_type(IdentifierT_$reflection())], ["Location", int32_type]]);
}

export class AlwaysDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AlwaysComb", "AlwaysFF"];
    }
    static AlwaysComb = new AlwaysDU(0, []);
    static AlwaysFF = new AlwaysDU(1, []);
}

export function AlwaysDU_$reflection() {
    return union_type("VerilogAST.AlwaysDU", [], AlwaysDU, () => [[], []]);
}

export class AlwaysConstruct extends Record {
    constructor(AlwaysType, Statement, ClkLoc, Location) {
        super();
        this.AlwaysType = AlwaysType;
        this.Statement = Statement;
        this.ClkLoc = (ClkLoc | 0);
        this.Location = (Location | 0);
    }
}

export function AlwaysConstruct_$reflection() {
    return record_type("VerilogAST.AlwaysConstruct", [], AlwaysConstruct, () => [["AlwaysType", AlwaysDU_$reflection()], ["Statement", StatementDU_$reflection()], ["ClkLoc", int32_type], ["Location", int32_type]]);
}

export class ItemDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["IOItem", "ParamDecl", "Decl", "ContStatement", "AlwaysConstruct", "ModuleInstantiation"];
    }
}

export function ItemDU_$reflection() {
    return union_type("VerilogAST.ItemDU", [], ItemDU, () => [[["Item", IOItem_$reflection()]], [["Item", ParameterItem_$reflection()]], [["Item", Declaration_$reflection()]], [["Item", ContinuousAssign_$reflection()]], [["Item", AlwaysConstruct_$reflection()]], [["Item", ModuleInstantiation_$reflection()]]]);
}

export class IOItem extends Record {
    constructor(DeclarationType, DataType, Range$, Variables, Location) {
        super();
        this.DeclarationType = DeclarationType;
        this.DataType = DataType;
        this.Range = Range$;
        this.Variables = Variables;
        this.Location = (Location | 0);
    }
}

export function IOItem_$reflection() {
    return record_type("VerilogAST.IOItem", [], IOItem, () => [["DeclarationType", DeclarationDU_$reflection()], ["DataType", DataTypeDU_$reflection()], ["Range", option_type(Range$_$reflection())], ["Variables", array_type(IdentifierT_$reflection())], ["Location", int32_type]]);
}

export class Parameter extends Record {
    constructor(Identifier, RHS, Location) {
        super();
        this.Identifier = Identifier;
        this.RHS = RHS;
        this.Location = (Location | 0);
    }
}

export function Parameter_$reflection() {
    return record_type("VerilogAST.Parameter", [], Parameter, () => [["Identifier", IdentifierT_$reflection()], ["RHS", ExpressionDU_$reflection()], ["Location", int32_type]]);
}

export class ParameterItem extends Record {
    constructor(DeclarationType, Parameters) {
        super();
        this.DeclarationType = DeclarationType;
        this.Parameters = Parameters;
    }
}

export function ParameterItem_$reflection() {
    return record_type("VerilogAST.ParameterItem", [], ParameterItem, () => [["DeclarationType", DeclarationDU_$reflection()], ["Parameters", array_type(Parameter_$reflection())]]);
}

export class ContinuousAssign extends Record {
    constructor(StatementType, Assignment, Location) {
        super();
        this.StatementType = StatementType;
        this.Assignment = Assignment;
        this.Location = (Location | 0);
    }
}

export function ContinuousAssign_$reflection() {
    return record_type("VerilogAST.ContinuousAssign", [], ContinuousAssign, () => [["StatementType", ContStatementDU_$reflection()], ["Assignment", Assignment_$reflection()], ["Location", int32_type]]);
}

export class ContStatementDU extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assign", "Wire"];
    }
    static Assign = new ContStatementDU(0, []);
    static Wire = new ContStatementDU(1, []);
}

export function ContStatementDU_$reflection() {
    return union_type("VerilogAST.ContStatementDU", [], ContStatementDU, () => [[], []]);
}

export class ModuleInstantiation extends Record {
    constructor(Module, Identifier, Parameters, Connections) {
        super();
        this.Module = Module;
        this.Identifier = Identifier;
        this.Parameters = Parameters;
        this.Connections = Connections;
    }
}

export function ModuleInstantiation_$reflection() {
    return record_type("VerilogAST.ModuleInstantiation", [], ModuleInstantiation, () => [["Module", IdentifierT_$reflection()], ["Identifier", IdentifierT_$reflection()], ["Parameters", option_type(array_type(OverridenParameter_$reflection()))], ["Connections", array_type(NamedPortConnection_$reflection())]]);
}

export class NamedPortConnection extends Record {
    constructor(PortId, Primary) {
        super();
        this.PortId = PortId;
        this.Primary = Primary;
    }
}

export function NamedPortConnection_$reflection() {
    return record_type("VerilogAST.NamedPortConnection", [], NamedPortConnection, () => [["PortId", IdentifierT_$reflection()], ["Primary", PrimaryDU_$reflection()]]);
}

export class OverridenParameter extends Record {
    constructor(Identifier, Value) {
        super();
        this.Identifier = Identifier;
        this.Value = Value;
    }
}

export function OverridenParameter_$reflection() {
    return record_type("VerilogAST.OverridenParameter", [], OverridenParameter, () => [["Identifier", IdentifierT_$reflection()], ["Value", ExpressionDU_$reflection()]]);
}

export class ModuleItems extends Record {
    constructor(ItemList) {
        super();
        this.ItemList = ItemList;
    }
}

export function ModuleItems_$reflection() {
    return record_type("VerilogAST.ModuleItems", [], ModuleItems, () => [["ItemList", array_type(ItemDU_$reflection())]]);
}

export class Module extends Record {
    constructor(Type, ModuleName, PortList, Locations, ModuleItems, EndLocation) {
        super();
        this.Type = Type;
        this.ModuleName = ModuleName;
        this.PortList = PortList;
        this.Locations = Locations;
        this.ModuleItems = ModuleItems;
        this.EndLocation = (EndLocation | 0);
    }
}

export function Module_$reflection() {
    return record_type("VerilogAST.Module", [], Module, () => [["Type", ModuleDU_$reflection()], ["ModuleName", IdentifierT_$reflection()], ["PortList", array_type(string_type)], ["Locations", array_type(string_type)], ["ModuleItems", ModuleItems_$reflection()], ["EndLocation", int32_type]]);
}

export class ASTNode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["IOItem", "ParamDecl", "ContStatement", "Declaration", "AlwaysConstruct", "Statement", "Case", "CaseItem", "IfStatement", "ForStatement", "Assignment", "AssignmentLHS", "Expression", "Primary", "Unary", "ParameterItem", "Range", "Number", "Item", "ModuleItems", "Module", "VerilogInput", "ModuleInstantiation"];
    }
}

export function ASTNode_$reflection() {
    return union_type("VerilogAST.ASTNode", [], ASTNode, () => [[["Item", IOItem_$reflection()]], [["Item", ParameterItem_$reflection()]], [["Item", ContinuousAssign_$reflection()]], [["Item", Declaration_$reflection()]], [["Item", AlwaysConstruct_$reflection()]], [["Item", StatementDU_$reflection()]], [["Item", CaseStatement_$reflection()]], [["Item", CaseItem_$reflection()]], [["Item", IfStatement_$reflection()]], [["Item", ForStatement_$reflection()]], [["Item", Assignment_$reflection()]], [["Item", AssignmentLHS_$reflection()]], [["Item", ExpressionDU_$reflection()]], [["Item", PrimaryDU_$reflection()]], [["Item", UnaryDU_$reflection()]], [["Item", ParameterItem_$reflection()]], [["Item", Range$_$reflection()]], [["Item", Number$_$reflection()]], [["Item", ItemDU_$reflection()]], [["Item", ModuleItems_$reflection()]], [["Item", Module_$reflection()]], [["Item", VerilogInput_$reflection()]], [["Item", ModuleInstantiation_$reflection()]]]);
}

export function tryEvalConst(number) {
    if (number.tag === 0) {
        const numBase = number.fields[1];
        const digits = number.fields[2];
        const matchValue = strToIntCheckWidth(number.fields[0], (numBase.tag === 0) ? ("0b" + digits) : ((numBase.tag === 2) ? ("0x" + digits) : digits));
        if (matchValue.tag === 1) {
            return toFail(printf("Shouldn\'t happen!")) | 0;
        }
        else {
            return ~~toInt32(matchValue.fields[0]) | 0;
        }
    }
    else {
        return number.fields[0] | 0;
    }
}

/**
 * Helper function to evaluate parameters to constants
 */
export function evalExprWithParams(paramExpr, paramMap) {
    const strip = (expr_mut) => {
        strip:
        while (true) {
            const expr = expr_mut;
            let matchResult, e;
            if (expr.tag === 13) {
                if (expr.fields[0].tag === 2) {
                    matchResult = 0;
                    e = expr.fields[0].fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    expr_mut = e;
                    continue strip;
                }
                default:
                    return expr;
            }
            break;
        }
    };
    const expr_1 = strip(paramExpr);
    let matchResult_1, n, n_1, n_2, id, lhs, op, rhs, lhs_1, op_1, rhs_1, lhs_2, op_2, rhs_2, lhs_3, rhs_3, lhs_4, rhs_4, lhs_5, rhs_5, lhs_6, rhs_6;
    switch (expr_1.tag) {
        case 14: {
            matchResult_1 = 0;
            n = expr_1.fields[0];
            break;
        }
        case 12: {
            if (expr_1.fields[0].tag === 1) {
                matchResult_1 = 1;
                n_1 = expr_1.fields[0].fields[0];
            }
            else {
                matchResult_1 = 11;
            }
            break;
        }
        case 13: {
            switch (expr_1.fields[0].tag) {
                case 1: {
                    matchResult_1 = 2;
                    n_2 = expr_1.fields[0].fields[0];
                    break;
                }
                case 0: {
                    if (expr_1.fields[0].fields[0].tag === 0) {
                        matchResult_1 = 3;
                        id = expr_1.fields[0].fields[0].fields[0];
                    }
                    else {
                        matchResult_1 = 11;
                    }
                    break;
                }
                default:
                    matchResult_1 = 11;
            }
            break;
        }
        case 9: {
            matchResult_1 = 4;
            lhs = expr_1.fields[1];
            op = expr_1.fields[0];
            rhs = expr_1.fields[2];
            break;
        }
        case 10: {
            matchResult_1 = 5;
            lhs_1 = expr_1.fields[1];
            op_1 = expr_1.fields[0];
            rhs_1 = expr_1.fields[2];
            break;
        }
        case 8: {
            matchResult_1 = 6;
            lhs_2 = expr_1.fields[1];
            op_2 = expr_1.fields[0];
            rhs_2 = expr_1.fields[2];
            break;
        }
        case 5: {
            matchResult_1 = 7;
            lhs_3 = expr_1.fields[0];
            rhs_3 = expr_1.fields[1];
            break;
        }
        case 2: {
            matchResult_1 = 8;
            lhs_4 = expr_1.fields[0];
            rhs_4 = expr_1.fields[1];
            break;
        }
        case 3: {
            matchResult_1 = 9;
            lhs_5 = expr_1.fields[0];
            rhs_5 = expr_1.fields[1];
            break;
        }
        case 4: {
            matchResult_1 = 10;
            lhs_6 = expr_1.fields[0];
            rhs_6 = expr_1.fields[1];
            break;
        }
        default:
            matchResult_1 = 11;
    }
    switch (matchResult_1) {
        case 0:
            return tryEvalConst(n) | 0;
        case 1:
            return op_UnaryNegation_Int32(tryEvalConst(n_1)) | 0;
        case 2:
            return tryEvalConst(n_2) | 0;
        case 3: {
            const matchValue = tryFind(id.Name, paramMap);
            if (matchValue == null) {
                return toFail(printf("Only parameters allowed to be used in width expressions. \'%s\' is not a parameter or is an undefined parameter."))(id.Name) | 0;
            }
            else {
                return matchValue | 0;
            }
        }
        case 4: {
            const l = evalExprWithParams(lhs, paramMap) | 0;
            const r = evalExprWithParams(rhs, paramMap) | 0;
            switch (op.tag) {
                case 14:
                    return (l + r) | 0;
                case 15:
                    return (l - r) | 0;
                default:
                    throw new Exception("Unsupported additive operator for parameter evaluation");
            }
        }
        case 5: {
            const l_1 = evalExprWithParams(lhs_1, paramMap) | 0;
            const r_1 = evalExprWithParams(rhs_1, paramMap) | 0;
            if (op_1.tag === 16) {
                return (l_1 * r_1) | 0;
            }
            else {
                throw new Exception("Unsupported multiplicative operator for parameter evaluation");
            }
        }
        case 6: {
            const l_2 = evalExprWithParams(lhs_2, paramMap) | 0;
            const r_2 = evalExprWithParams(rhs_2, paramMap) | 0;
            switch (op_2.tag) {
                case 17:
                    return (l_2 << r_2) | 0;
                case 18:
                    return (l_2 >> r_2) | 0;
                case 19:
                    return (l_2 >> r_2) | 0;
                default:
                    throw new Exception("Unsupported shift operator for parameter evaluation");
            }
        }
        case 7:
            return (evalExprWithParams(lhs_3, paramMap) & evalExprWithParams(rhs_3, paramMap)) | 0;
        case 8:
            return (evalExprWithParams(lhs_4, paramMap) | evalExprWithParams(rhs_4, paramMap)) | 0;
        case 9:
            return (evalExprWithParams(lhs_5, paramMap) ^ evalExprWithParams(rhs_5, paramMap)) | 0;
        case 10:
            return ~(evalExprWithParams(lhs_6, paramMap) ^ evalExprWithParams(rhs_6, paramMap)) | 0;
        default:
            throw new Exception("Expression does not evaluate to a constant integer or parameter reference");
    }
}

/**
 * Helper function to convert expressions to ints and back (for width checking)
 */
export function evalExpr(expr) {
    let matchResult, n, n_1, n_2, lhs, op, rhs, lhs_1, op_1, rhs_1, lhs_2, op_2, rhs_2, lhs_3, rhs_3, lhs_4, rhs_4, lhs_5, rhs_5, lhs_6, rhs_6;
    switch (expr.tag) {
        case 14: {
            matchResult = 0;
            n = expr.fields[0];
            break;
        }
        case 12: {
            if (expr.fields[0].tag === 1) {
                matchResult = 1;
                n_1 = expr.fields[0].fields[0];
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 13: {
            if (expr.fields[0].tag === 1) {
                matchResult = 2;
                n_2 = expr.fields[0].fields[0];
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 9: {
            matchResult = 3;
            lhs = expr.fields[1];
            op = expr.fields[0];
            rhs = expr.fields[2];
            break;
        }
        case 10: {
            matchResult = 4;
            lhs_1 = expr.fields[1];
            op_1 = expr.fields[0];
            rhs_1 = expr.fields[2];
            break;
        }
        case 8: {
            matchResult = 5;
            lhs_2 = expr.fields[1];
            op_2 = expr.fields[0];
            rhs_2 = expr.fields[2];
            break;
        }
        case 5: {
            matchResult = 6;
            lhs_3 = expr.fields[0];
            rhs_3 = expr.fields[1];
            break;
        }
        case 2: {
            matchResult = 7;
            lhs_4 = expr.fields[0];
            rhs_4 = expr.fields[1];
            break;
        }
        case 3: {
            matchResult = 8;
            lhs_5 = expr.fields[0];
            rhs_5 = expr.fields[1];
            break;
        }
        case 4: {
            matchResult = 9;
            lhs_6 = expr.fields[0];
            rhs_6 = expr.fields[1];
            break;
        }
        default:
            matchResult = 10;
    }
    switch (matchResult) {
        case 0:
            return tryEvalConst(n) | 0;
        case 1:
            return op_UnaryNegation_Int32(tryEvalConst(n_1)) | 0;
        case 2:
            return tryEvalConst(n_2) | 0;
        case 3: {
            const l = evalExpr(lhs) | 0;
            const r = evalExpr(rhs) | 0;
            switch (op.tag) {
                case 14:
                    return (l + r) | 0;
                case 15:
                    return (l - r) | 0;
                default:
                    throw new Exception("Unsupported operator for additive eval");
            }
        }
        case 4: {
            const l_1 = evalExpr(lhs_1) | 0;
            const r_1 = evalExpr(rhs_1) | 0;
            if (op_1.tag === 16) {
                return (l_1 * r_1) | 0;
            }
            else {
                throw new Exception("Unsupported operator for multiplicative eval");
            }
        }
        case 5: {
            const l_2 = evalExpr(lhs_2) | 0;
            const r_2 = evalExpr(rhs_2) | 0;
            switch (op_2.tag) {
                case 17:
                    return (l_2 << r_2) | 0;
                case 18:
                    return (l_2 >> r_2) | 0;
                case 19:
                    return (l_2 >> r_2) | 0;
                default:
                    throw new Exception("Unsupported operator for shift eval");
            }
        }
        case 6:
            return (evalExpr(lhs_3) & evalExpr(rhs_3)) | 0;
        case 7:
            return (evalExpr(lhs_4) | evalExpr(rhs_4)) | 0;
        case 8:
            return (evalExpr(lhs_5) ^ evalExpr(rhs_5)) | 0;
        case 9:
            return ~(evalExpr(lhs_6) ^ evalExpr(rhs_6)) | 0;
        default:
            throw new Exception("Expression does not evaluate to a constant integer");
    }
}

export function parseDataType(_arg) {
    switch (_arg) {
        case "bit":
            return DataTypeDU.Bit;
        case "wire":
            return DataTypeDU.WireType;
        default:
            throw new Exception(concat("Unknown DataType: ", _arg));
    }
}

export function parseDeclarationType(_arg) {
    switch (_arg) {
        case "input":
            return DeclarationDU.InputDecl;
        case "output":
            return DeclarationDU.OutputDecl;
        case "logic":
            return DeclarationDU.LogicDecl;
        case "parameter":
            return DeclarationDU.ParameterDecl;
        default:
            throw new Exception(concat("Unknown DeclarationType: ", _arg));
    }
}

export function parseOperation(_arg) {
    switch (_arg) {
        case "||":
            return OperatorDU.Lor;
        case "&&":
            return OperatorDU.Land;
        case "|":
            return OperatorDU.OrOp;
        case "^":
            return OperatorDU.Xor;
        case "~^":
        case "^~":
            return OperatorDU.Xnor;
        case "&":
            return OperatorDU.AndOp;
        case "~&":
            return OperatorDU.Nand;
        case "~|":
            return OperatorDU.Nor;
        case "==":
            return OperatorDU.Eq;
        case "!=":
            return OperatorDU.Neq;
        case "<":
            return OperatorDU.Lt;
        case "<=":
            return OperatorDU.Lte;
        case ">":
            return OperatorDU.Gt;
        case ">=":
            return OperatorDU.Gte;
        case "+":
            return OperatorDU.Plus;
        case "-":
            return OperatorDU.Minus;
        case "*":
            return OperatorDU.Mult;
        case "<<":
            return OperatorDU.Sll;
        case ">>":
            return OperatorDU.Srl;
        case ">>>":
            return OperatorDU.Sra;
        case "!":
        case "~":
            return OperatorDU.NotOp;
        default:
            throw new Exception(concat("Unknown operator: ", _arg));
    }
}

export function convertNumber(raw) {
    let option_1, option_4, option_7;
    const matchValue = raw.NumberType;
    switch (matchValue) {
        case "decimal":
            return new Number$(/* Unsigned */ 1, [value_7((option_1 = raw.UnsignedNumber, (option_1 != null) ? parse(option_1, 511, false, 32) : undefined)), raw.Location]);
        case "unsigned":
            return new Number$(/* Unsigned */ 1, [value_7((option_4 = raw.UnsignedNumber, (option_4 != null) ? parse(option_4, 511, false, 32) : undefined)), raw.Location]);
        case "all": {
            const bits = value_7((option_7 = raw.Bits, (option_7 != null) ? parse(option_7, 511, false, 32) : undefined)) | 0;
            const allnumber = value_7(raw.AllNumber);
            const matchValue_1 = raw.Base;
            if (matchValue_1 == null) {
                throw new Exception("Base must be specified for \'all\' number type");
            }
            else {
                switch (matchValue_1) {
                    case "\'d":
                        return new Number$(/* All */ 0, [bits, BaseDU.Decimal, allnumber, raw.Location]);
                    case "\'b":
                        return new Number$(/* All */ 0, [bits, BaseDU.Binary, allnumber, raw.Location]);
                    case "\'h":
                        return new Number$(/* All */ 0, [bits, BaseDU.Hex, allnumber, raw.Location]);
                    default: {
                        const b = matchValue_1;
                        throw new Exception(concat("Unknown number base: ", b));
                    }
                }
            }
        }
        default:
            throw new Exception(concat("Unknown number type: ", matchValue));
    }
}

export function parseSelectType(_arg) {
    switch (_arg) {
        case "plus":
            return SelectDU.PlusWidth;
        case "minus":
            return SelectDU.MinusWidth;
        default:
            throw new Exception(concat("Unknown select type: ", _arg));
    }
}

export function convertExpression(raw) {
    const matchValue = raw.Type;
    switch (matchValue) {
        case "unary":
            return new ExpressionDU(/* Unary */ 13, [convertUnary(value_7(raw.Unary))]);
        case "unary_unsigned":
            return new ExpressionDU(/* UnaryUnsigned */ 14, [convertNumber(value_7(value_7(raw.Unary).Number))]);
        case "negation":
            return new ExpressionDU(/* Negation */ 12, [convertUnary(value_7(raw.Unary))]);
        case "reduction":
            return new ExpressionDU(/* Reduction */ 11, [parseOperation(value_7(raw.Operator)), new ExpressionDU(/* Unary */ 13, [convertUnary(value_7(raw.Unary))])]);
        case "multiplicative":
            return new ExpressionDU(/* Multiplicative */ 10, [parseOperation(value_7(raw.Operator)), convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "additive":
            return new ExpressionDU(/* Additive */ 9, [parseOperation(value_7(raw.Operator)), convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "SHIFT":
        case "shift":
            return new ExpressionDU(/* ShiftExpr */ 8, [parseOperation(value_7(raw.Operator)), convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "comparison":
            return new ExpressionDU(/* Comparison */ 7, [parseOperation(value_7(raw.Operator)), convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "equality":
            return new ExpressionDU(/* Equality */ 6, [parseOperation(value_7(raw.Operator)), convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "bitwise_AND":
            return new ExpressionDU(/* BitwiseAnd */ 5, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "bitwise_OR":
            return new ExpressionDU(/* BitwiseOr */ 2, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "bitwise_XOR": {
            const matchValue_1 = raw.Operator;
            let matchResult;
            if (matchValue_1 != null) {
                switch (matchValue_1) {
                    case "~^":
                    case "^~": {
                        matchResult = 0;
                        break;
                    }
                    default:
                        matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new ExpressionDU(/* BitwiseXnor */ 4, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
                default:
                    return new ExpressionDU(/* BitwiseXor */ 3, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
            }
        }
        case "logical_AND":
            return new ExpressionDU(/* LogicalAnd */ 1, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "logical_OR":
            return new ExpressionDU(/* LogicalOr */ 0, [convertExpression(value_7(raw.Head)), convertExpression(value_7(raw.Tail))]);
        case "conditional_cond": {
            const cond = convertExpression(value_7(raw.Head));
            const result = value_7(raw.Tail);
            return new ExpressionDU(/* ConditionalOp */ 15, [cond, convertExpression(value_7(result.Head)), convertExpression(value_7(result.Tail))]);
        }
        case "conditional_result":
            throw new Exception("conditional_result should not be converted directly");
        default:
            throw new Exception(concat("Unknown expression type: ", matchValue));
    }
}

export function convertUnary(raw) {
    const flattenUnaryList = (raw_1) => {
        let option_3;
        if (raw_1.Type === "unary_list") {
            let head;
            const option_1 = raw_1.Head;
            head = ((option_1 != null) ? convertExpression(option_1) : undefined);
            const tail = defaultArg((option_3 = raw_1.Tail, (option_3 != null) ? flattenUnaryList(option_3) : undefined), []);
            if (head == null) {
                return tail;
            }
            else {
                return append([head], tail);
            }
        }
        else {
            return [convertExpression(raw_1)];
        }
    };
    const matchValue_1 = raw.Type;
    switch (matchValue_1) {
        case "primary":
            return new UnaryDU(/* Primary */ 0, [convertPrimary(value_7(raw.Primary))]);
        case "number":
            return new UnaryDU(/* Number */ 1, [convertNumber(value_7(raw.Number))]);
        case "parenthesis":
            return new UnaryDU(/* Parenthesis */ 2, [convertExpression(value_7(raw.Expression))]);
        case "concat":
            return new UnaryDU(/* Concat */ 3, [flattenUnaryList(value_7(raw.Expression))]);
        case "param_number":
            return new UnaryDU(/* ParamNumber */ 4, [convertPrimary(value_7(raw.ParamNumber).Primary), value_7(raw.ParamNumber).Bits]);
        default:
            throw new Exception(concat("Unknown unary type: ", matchValue_1));
    }
}

export function convertPrimary(raw) {
    let option_1, option_4, option_7, option_11, option_14;
    const matchValue = raw.PrimaryType;
    switch (matchValue) {
        case "identifier":
            return new PrimaryDU(/* Identifier */ 0, [raw.Primary]);
        case "identifier_bit":
            return new PrimaryDU(/* IdentifierBit */ 1, [raw.Primary, value_7((option_1 = raw.BitsStart, (option_1 != null) ? parse(option_1, 511, false, 32) : undefined))]);
        case "identifier_bit2": {
            const idx_1 = convertExpression(value_7(raw.Expression));
            let idxInt;
            try {
                idxInt = evalExpr(idx_1);
            }
            catch (matchValue_1) {
                idxInt = undefined;
            }
            if (idxInt == null) {
                return new PrimaryDU(/* VariableBitSelect */ 3, [raw.Primary, idx_1]);
            }
            else {
                return new PrimaryDU(/* IdentifierBit */ 1, [raw.Primary, idxInt]);
            }
        }
        case "identifier_bits":
            return new PrimaryDU(/* IdentifierBits */ 2, [raw.Primary, value_7((option_4 = raw.BitsStart, (option_4 != null) ? parse(option_4, 511, false, 32) : undefined)), value_7((option_7 = raw.BitsEnd, (option_7 != null) ? parse(option_7, 511, false, 32) : undefined))]);
        case "identifier_bits_select":
            return new PrimaryDU(/* IdentifierBitsSelect */ 4, [raw.Primary, convertExpression(value_7(raw.Expression)), value_7(raw.Width), parseSelectType(value_7(raw.SelectType))]);
        case "identifier_array":
            return new PrimaryDU(/* IdentifierArray */ 5, [raw.Primary, map(convertArraySelect, defaultArg(raw.ArrayIndices, [])), value_7((option_11 = raw.BitsStart, (option_11 != null) ? parse(option_11, 511, false, 32) : undefined)), value_7((option_14 = raw.BitsEnd, (option_14 != null) ? parse(option_14, 511, false, 32) : undefined))]);
        case "identifier_array2": {
            const indices_1 = map(convertArraySelect, defaultArg(raw.ArrayIndices, []));
            const idx_2 = convertExpression(value_7(raw.Expression));
            let idxInt_1;
            try {
                idxInt_1 = evalExpr(idx_2);
            }
            catch (matchValue_2) {
                idxInt_1 = undefined;
            }
            if (idxInt_1 == null) {
                return new PrimaryDU(/* VariableArrayBitSel */ 6, [raw.Primary, indices_1, idx_2]);
            }
            else {
                const i_1 = idxInt_1 | 0;
                return new PrimaryDU(/* IdentifierArray */ 5, [raw.Primary, indices_1, i_1, i_1]);
            }
        }
        default:
            throw new Exception(concat("Unknown primary type: ", matchValue));
    }
}

export function convertArraySelect(raw) {
    const matchValue = raw.ArrayType;
    switch (matchValue) {
        case "const_array":
            return new ArraySelect(/* ConstArraySelect */ 0, [parse(value_7(raw.WordSelect), 511, false, 32)]);
        case "var_array":
            return new ArraySelect(/* VarArraySelect */ 1, [convertExpression(value_7(raw.VariableArraySelect))]);
        default:
            throw new Exception(concat("Unknown array type: ", matchValue));
    }
}

export function convertAssignmentLHS(raw) {
    let option_1;
    const prim = new PrimaryT("", raw.PrimaryType, raw.BitsStart, raw.BitsEnd, raw.Primary, raw.VariableBitSelect, raw.Width, raw.ArrayIndices, raw.SelectType);
    if (convertPrimary(prim).tag === 3) {
        return new AssignmentLHS(convertPrimary(prim), (option_1 = raw.VariableBitSelect, (option_1 != null) ? convertExpression(option_1) : undefined));
    }
    else {
        return new AssignmentLHS(convertPrimary(prim), undefined);
    }
}

export function convertAssignment(raw, assignType) {
    return new Assignment(assignType, convertAssignmentLHS(raw.LHS), convertExpression(raw.RHS));
}

export function convertRange(raw) {
    return new Range$(convertExpression(raw.Start), convertExpression(raw.End), raw.Location);
}

export function convertStatement(raw) {
    let option_1;
    const matchValue = raw.BlockingAssign;
    const matchValue_1 = raw.NonBlockingAssign;
    const matchValue_2 = raw.CaseStatement;
    const matchValue_3 = raw.Conditional;
    const matchValue_4 = raw.SeqBlock;
    const matchValue_5 = raw.ForStatement;
    let matchResult, blocking, nonblocking, case$, cond, seqBlock, forStmt;
    if (matchValue == null) {
        if (matchValue_1 == null) {
            if (matchValue_2 == null) {
                if (matchValue_3 == null) {
                    if (matchValue_4 == null) {
                        if (matchValue_5 != null) {
                            matchResult = 5;
                            forStmt = matchValue_5;
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else if (matchValue_5 == null) {
                        matchResult = 4;
                        seqBlock = matchValue_4;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 3;
                        cond = matchValue_3;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 2;
                        case$ = matchValue_2;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else if (matchValue_2 == null) {
            if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 1;
                        nonblocking = matchValue_1;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else {
            matchResult = 6;
        }
    }
    else if (matchValue_1 == null) {
        if (matchValue_2 == null) {
            if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 0;
                        blocking = matchValue;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else {
            matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0:
            return new StatementDU(/* BlockingAssign */ 1, [convertAssignment(blocking.Assignment, AssignDU.Blocking), raw.Location]);
        case 1:
            return new StatementDU(/* NonBlockingAssign */ 0, [convertAssignment(nonblocking.Assignment, AssignDU.NonBlocking), raw.Location]);
        case 2:
            return new StatementDU(/* Case */ 3, [convertCaseStatement(case$), raw.Location]);
        case 3:
            return new StatementDU(/* Conditional */ 4, [convertIfStatement(cond.IfStatement), (option_1 = cond.ElseStatement, (option_1 != null) ? convertStatement(option_1) : undefined), raw.Location]);
        case 4:
            return new StatementDU(/* SeqBlock */ 2, [map(convertStatement, seqBlock.Statements), seqBlock.Location]);
        case 5:
            return new StatementDU(/* ForStatement */ 5, [convertForStatement(forStmt), forStmt.Location]);
        default:
            throw new Exception("Invalid statement: multiple or no fields set");
    }
}

export function convertIfStatement(raw) {
    return new IfStatement(convertExpression(raw.Condition), convertStatement(raw.Statement), raw.Location);
}

export function convertCaseStatement(raw) {
    let option_1;
    return new CaseStatement(convertExpression(raw.Expression), map(convertCaseItem, raw.CaseItems), (option_1 = raw.Default, (option_1 != null) ? convertStatement(option_1) : undefined), raw.Location);
}

export function convertCaseItem(raw) {
    return new CaseItem(map(convertNumber, raw.Expressions), convertStatement(raw.Statement));
}

export function convertForStatement(raw) {
    return new ForStatement(convertAssignment(raw.Initialisation, AssignDU.Blocking), convertExpression(raw.Condition), convertAssignment(raw.Step, AssignDU.Blocking), convertStatement(raw.Statement), raw.Location);
}

export function convertDeclaration(raw) {
    let option_1, option_3;
    return new Declaration(parseDeclarationType(raw.DeclarationType), parseDataType(raw.DataType), (option_1 = raw.Range, (option_1 != null) ? convertRange(option_1) : undefined), (option_3 = raw.ArrayRanges, (option_3 != null) ? map(convertRange, option_3) : undefined), raw.Variables, raw.Location);
}

export function convertIOItem(raw) {
    let option_1;
    return new IOItem(parseDeclarationType(raw.DeclarationType), parseDataType(raw.DataType), (option_1 = raw.Range, (option_1 != null) ? convertRange(option_1) : undefined), raw.Variables, raw.Location);
}

export function convertParameter(raw) {
    return new Parameter(raw.Identifier, convertExpression(raw.RHS), raw.Location);
}

export function convertParameterItem(raw) {
    return new ParameterItem(parseDeclarationType(raw.DeclarationType), map(convertParameter, raw.Parameters));
}

export function parseAlwaysType(_arg) {
    switch (_arg) {
        case "always_comb":
            return AlwaysDU.AlwaysComb;
        case "always_ff":
            return AlwaysDU.AlwaysFF;
        default:
            throw new Exception(concat("Unknown always type: ", _arg));
    }
}

export function convertAlwaysConstruct(raw) {
    return new AlwaysConstruct(parseAlwaysType(raw.AlwaysType), convertStatement(raw.Statement), raw.ClkLoc, raw.Location);
}

export function parseContStatementType(_arg) {
    switch (_arg) {
        case "assign":
            return ContStatementDU.Assign;
        case "wire":
            return ContStatementDU.Wire;
        default:
            throw new Exception(concat("Unknown continuous assignment statement type: ", _arg));
    }
}

export function convertContinuousAssign(raw) {
    return new ContinuousAssign(parseContStatementType(raw.StatementType), convertAssignment(raw.Assignment, AssignDU.Blocking), raw.Location);
}

export function convertNamedPortConnection(raw) {
    return new NamedPortConnection(raw.PortId, convertPrimary(raw.Primary));
}

export function convertOverridenParameter(raw) {
    return new OverridenParameter(raw.Identifier, convertExpression(raw.Value));
}

export function convertModuleInstantiation(raw) {
    let option_1;
    return new ModuleInstantiation(raw.Module, raw.Identifier, (option_1 = raw.Parameters, (option_1 != null) ? map(convertOverridenParameter, option_1) : undefined), map(convertNamedPortConnection, raw.Connections));
}

export function convertItem(raw) {
    const matchValue = raw.IODecl;
    const matchValue_1 = raw.ParamDecl;
    const matchValue_2 = raw.Decl;
    const matchValue_3 = raw.Statement;
    const matchValue_4 = raw.AlwaysConstruct;
    const matchValue_5 = raw.ModuleInstantiation;
    let matchResult, io, param, decl, stmt, always, modInst;
    if (matchValue == null) {
        if (matchValue_1 == null) {
            if (matchValue_2 == null) {
                if (matchValue_3 == null) {
                    if (matchValue_4 == null) {
                        if (matchValue_5 != null) {
                            matchResult = 5;
                            modInst = matchValue_5;
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else if (matchValue_5 == null) {
                        matchResult = 4;
                        always = matchValue_4;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 3;
                        stmt = matchValue_3;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 2;
                        decl = matchValue_2;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else if (matchValue_2 == null) {
            if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 1;
                        param = matchValue_1;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else {
            matchResult = 6;
        }
    }
    else if (matchValue_1 == null) {
        if (matchValue_2 == null) {
            if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        matchResult = 0;
                        io = matchValue;
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
        }
        else {
            matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0:
            return new ItemDU(/* IOItem */ 0, [convertIOItem(io)]);
        case 1:
            return new ItemDU(/* ParamDecl */ 1, [convertParameterItem(param)]);
        case 2:
            return new ItemDU(/* Decl */ 2, [convertDeclaration(decl)]);
        case 3:
            return new ItemDU(/* ContStatement */ 3, [convertContinuousAssign(stmt)]);
        case 4:
            return new ItemDU(/* AlwaysConstruct */ 4, [convertAlwaysConstruct(always)]);
        case 5:
            return new ItemDU(/* ModuleInstantiation */ 5, [convertModuleInstantiation(modInst)]);
        default:
            throw new Exception("Invalid item: multiple or no fields set");
    }
}

export function convertModuleItems(raw) {
    return new ModuleItems(map(convertItem, raw.ItemList));
}

export function parseModuleType(_arg) {
    switch (_arg) {
        case "module_old":
            return ModuleDU.ModuleOld;
        case "module_new":
            return ModuleDU.ModuleNew;
        default:
            throw new Exception(concat("Unknown module type: ", _arg));
    }
}

export function convertModule(raw) {
    return new Module(parseModuleType(raw.Type), raw.ModuleName, raw.PortList, raw.Locations, convertModuleItems(raw.ModuleItems), raw.EndLocation);
}

/**
 * converts StatementT into StatementDU
 */
export function getItem(item) {
    switch (item.tag) {
        case 1:
            return new ASTNode(/* ParamDecl */ 1, [item.fields[0]]);
        case 2:
            return new ASTNode(/* Declaration */ 3, [item.fields[0]]);
        case 3:
            return new ASTNode(/* ContStatement */ 2, [item.fields[0]]);
        case 4:
            return new ASTNode(/* AlwaysConstruct */ 4, [item.fields[0]]);
        case 5:
            return new ASTNode(/* ModuleInstantiation */ 22, [item.fields[0]]);
        default:
            return new ASTNode(/* IOItem */ 0, [item.fields[0]]);
    }
}

/**
 * Helper functions to extract details from primaries
 */
export function getPrimaryName(p) {
    let id;
    switch (p.tag) {
        case 1: {
            id = p.fields[0];
            break;
        }
        case 3: {
            id = p.fields[0];
            break;
        }
        case 2: {
            id = p.fields[0];
            break;
        }
        case 4: {
            id = p.fields[0];
            break;
        }
        case 5: {
            id = p.fields[0];
            break;
        }
        case 6: {
            id = p.fields[0];
            break;
        }
        default:
            id = p.fields[0];
    }
    return id.Name;
}

export function getPrimaryLocation(p) {
    let id;
    switch (p.tag) {
        case 1: {
            id = p.fields[0];
            break;
        }
        case 3: {
            id = p.fields[0];
            break;
        }
        case 2: {
            id = p.fields[0];
            break;
        }
        case 4: {
            id = p.fields[0];
            break;
        }
        case 5: {
            id = p.fields[0];
            break;
        }
        case 6: {
            id = p.fields[0];
            break;
        }
        default:
            id = p.fields[0];
    }
    return id.Location | 0;
}

export function getPrimaryRange(p, paramMap) {
    switch (p.tag) {
        case 5:
            return undefined;
        case 3:
            try {
                const idxVal = evalExprWithParams(p.fields[1], paramMap) | 0;
                return [idxVal, idxVal];
            }
            catch (matchValue) {
                return undefined;
            }
        case 6:
            try {
                const idxVal_1 = evalExprWithParams(p.fields[2], paramMap) | 0;
                return [idxVal_1, idxVal_1];
            }
            catch (matchValue_1) {
                return undefined;
            }
        case 1: {
            const idx_2 = p.fields[1] | 0;
            return [idx_2, idx_2];
        }
        case 2:
            return [p.fields[1], p.fields[2]];
        case 4: {
            const width = p.fields[2] | 0;
            const bStart = evalExpr(p.fields[1]) | 0;
            return [bStart, (p.fields[3].tag === 1) ? ((bStart - width) + 1) : ((bStart + width) - 1)];
        }
        default:
            return undefined;
    }
}

export function substLoopVar(loopVarName, value, width, stmt) {
    let option_3, option_5, bind$0040, bind$0040_1;
    const substLoopExpr = (loopVarName_1) => ((value_1) => ((width_1) => ((expr) => {
        const substUnary = (unary) => {
            let matchResult, id_7;
            if (unary.tag === 0) {
                switch (unary.fields[0].tag) {
                    case 1: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    case 3: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    case 2: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    case 4: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    case 5: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    case 6: {
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                        break;
                    }
                    default:
                        if (unary.fields[0].fields[0].Name === loopVarName_1) {
                            matchResult = 0;
                            id_7 = unary.fields[0].fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new UnaryDU(/* Number */ 1, [new Number$(/* All */ 0, [width_1, BaseDU.Decimal, int32ToString(value_1), id_7.Location])]);
                default:
                    switch (unary.tag) {
                        case 1:
                            return unary;
                        case 2:
                            return new UnaryDU(/* Parenthesis */ 2, [substLoopExpr(loopVarName_1)(value_1)(width_1)(unary.fields[0])]);
                        case 3:
                            return new UnaryDU(/* Concat */ 3, [map(substLoopExpr(loopVarName_1)(value_1)(width_1), unary.fields[0])]);
                        case 4:
                            return new UnaryDU(/* ParamNumber */ 4, [substLoopPrimary(loopVarName_1)(value_1)(unary.fields[0]), unary.fields[1]]);
                        default:
                            return new UnaryDU(/* Primary */ 0, [substLoopPrimary(loopVarName_1)(value_1)(unary.fields[0])]);
                    }
            }
        };
        return (expr.tag === 1) ? (new ExpressionDU(/* LogicalAnd */ 1, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 2) ? (new ExpressionDU(/* BitwiseOr */ 2, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 3) ? (new ExpressionDU(/* BitwiseXor */ 3, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 4) ? (new ExpressionDU(/* BitwiseXnor */ 4, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 5) ? (new ExpressionDU(/* BitwiseAnd */ 5, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 6) ? (new ExpressionDU(/* Equality */ 6, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : ((expr.tag === 7) ? (new ExpressionDU(/* Comparison */ 7, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : ((expr.tag === 8) ? (new ExpressionDU(/* ShiftExpr */ 8, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : ((expr.tag === 9) ? (new ExpressionDU(/* Additive */ 9, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : ((expr.tag === 10) ? (new ExpressionDU(/* Multiplicative */ 10, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : ((expr.tag === 11) ? (new ExpressionDU(/* Reduction */ 11, [expr.fields[0], substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])])) : ((expr.tag === 12) ? (new ExpressionDU(/* Negation */ 12, [substUnary(expr.fields[0])])) : ((expr.tag === 13) ? (new ExpressionDU(/* Unary */ 13, [substUnary(expr.fields[0])])) : ((expr.tag === 14) ? expr : ((expr.tag === 15) ? (new ExpressionDU(/* ConditionalOp */ 15, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[2])])) : (new ExpressionDU(/* LogicalOr */ 0, [substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[0]), substLoopExpr(loopVarName_1)(value_1)(width_1)(expr.fields[1])]))))))))))))))));
    })));
    const substLoopPrimary = (loopVarName_2) => ((value_2) => ((p_2) => ((p_2.tag === 1) ? p_2 : ((p_2.tag === 3) ? ((p_2.fields[0].Name === loopVarName_2) ? (new PrimaryDU(/* IdentifierBit */ 1, [p_2.fields[0], evalExpr(substLoopExpr(loopVarName_2)(value_2)(width)(p_2.fields[1]))])) : (new PrimaryDU(/* VariableBitSelect */ 3, [p_2.fields[0], substLoopExpr(loopVarName_2)(value_2)(width)(p_2.fields[1])]))) : ((p_2.tag === 2) ? p_2 : ((p_2.tag === 4) ? (new PrimaryDU(/* IdentifierBitsSelect */ 4, [p_2.fields[0], substLoopExpr(loopVarName_2)(value_2)(p_2.fields[2])(p_2.fields[1]), p_2.fields[2], p_2.fields[3]])) : ((p_2.tag === 5) ? (new PrimaryDU(/* IdentifierArray */ 5, [p_2.fields[0], map(substLoopArraySel(loopVarName_2)(value_2), p_2.fields[1]), p_2.fields[2], p_2.fields[3]])) : ((p_2.tag === 6) ? (new PrimaryDU(/* VariableArrayBitSel */ 6, [p_2.fields[0], map(substLoopArraySel(loopVarName_2)(value_2), p_2.fields[1]), substLoopExpr(loopVarName_2)(value_2)(width)(p_2.fields[2])])) : p_2))))))));
    const substLoopArraySel = (loopVarName_3) => ((value_3) => ((a_11) => ((a_11.tag === 1) ? (new ArraySelect(/* VarArraySelect */ 1, [substLoopExpr(loopVarName_3)(value_3)(width)(a_11.fields[0])])) : a_11)));
    const substAssign = (a_12) => {
        let lhs_1, loopVarBool, vbs, mapping_3, option_1, primary$0027, matchValue, expr_1;
        return new Assignment(a_12.Type, (lhs_1 = a_12.LHS, (loopVarBool = (getPrimaryName(lhs_1.PrimaryType) === loopVarName), (vbs = ((mapping_3 = substLoopExpr(loopVarName)(value)(width), (option_1 = lhs_1.VariableBitSelect, (option_1 != null) ? mapping_3(option_1) : undefined))), (primary$0027 = (loopVarBool ? lhs_1.PrimaryType : ((matchValue = lhs_1.PrimaryType, (matchValue.tag === 1) ? lhs_1.PrimaryType : ((matchValue.tag === 3) ? ((matchValue.fields[0].Name === loopVarName) ? (new PrimaryDU(/* IdentifierBit */ 1, [matchValue.fields[0], evalExpr(substLoopExpr(loopVarName)(value)(width)(matchValue.fields[1]))])) : ((vbs == null) ? lhs_1.PrimaryType : ((expr_1 = vbs, (() => {
            try {
                return new PrimaryDU(/* IdentifierBit */ 1, [matchValue.fields[0], evalExpr(expr_1)]);
            }
            catch (matchValue_1) {
                return new PrimaryDU(/* VariableBitSelect */ 3, [matchValue.fields[0], expr_1]);
            }
        })())))) : ((matchValue.tag === 2) ? (new PrimaryDU(/* IdentifierBits */ 2, [matchValue.fields[0], matchValue.fields[1], matchValue.fields[2]])) : ((matchValue.tag === 4) ? (new PrimaryDU(/* IdentifierBitsSelect */ 4, [matchValue.fields[0], substLoopExpr(loopVarName)(value)(width)(matchValue.fields[1]), matchValue.fields[2], matchValue.fields[3]])) : ((matchValue.tag === 5) ? (new PrimaryDU(/* IdentifierArray */ 5, [matchValue.fields[0], map(substLoopArraySel(loopVarName)(value), matchValue.fields[1]), matchValue.fields[2], matchValue.fields[3]])) : ((matchValue.tag === 6) ? (new PrimaryDU(/* VariableArrayBitSel */ 6, [matchValue.fields[0], map(substLoopArraySel(loopVarName)(value), matchValue.fields[1]), substLoopExpr(loopVarName)(value)(width)(matchValue.fields[2])])) : lhs_1.PrimaryType)))))))), new AssignmentLHS(primary$0027, (primary$0027.tag === 3) ? vbs : ((primary$0027.tag === 6) ? vbs : undefined)))))), substLoopExpr(loopVarName)(value)(width)(a_12.RHS));
    };
    switch (stmt.tag) {
        case 0:
            return new StatementDU(/* NonBlockingAssign */ 0, [substAssign(stmt.fields[0]), stmt.fields[1]]);
        case 2:
            return new StatementDU(/* SeqBlock */ 2, [map((stmt_1) => substLoopVar(loopVarName, value, width, stmt_1), stmt.fields[0]), stmt.fields[1]]);
        case 4: {
            const ifStmt = stmt.fields[0];
            return new StatementDU(/* Conditional */ 4, [new IfStatement(substLoopExpr(loopVarName)(value)(width)(ifStmt.Condition), substLoopVar(loopVarName, value, width, ifStmt.Statement), ifStmt.Location), (option_3 = stmt.fields[1], (option_3 != null) ? substLoopVar(loopVarName, value, width, option_3) : undefined), stmt.fields[2]]);
        }
        case 3: {
            const c_1 = stmt.fields[0];
            return new StatementDU(/* Case */ 3, [new CaseStatement(substLoopExpr(loopVarName)(value)(width)(c_1.Expression), map((ci) => (new CaseItem(ci.Expressions, substLoopVar(loopVarName, value, width, ci.Statement))), c_1.CaseItems), (option_5 = c_1.Default, (option_5 != null) ? substLoopVar(loopVarName, value, width, option_5) : undefined), c_1.Location), stmt.fields[1]]);
        }
        case 5: {
            const f_1 = stmt.fields[0];
            return new StatementDU(/* ForStatement */ 5, [new ForStatement((bind$0040 = f_1.Initialisation, new Assignment(bind$0040.Type, bind$0040.LHS, substLoopExpr(loopVarName)(value)(width)(f_1.Initialisation.RHS))), substLoopExpr(loopVarName)(value)(width)(f_1.Condition), (bind$0040_1 = f_1.Step, new Assignment(bind$0040_1.Type, bind$0040_1.LHS, substLoopExpr(loopVarName)(value)(width)(f_1.Step.RHS))), substLoopVar(loopVarName, value, width, f_1.Statement), f_1.Location), stmt.fields[1]]);
        }
        default:
            return new StatementDU(/* BlockingAssign */ 1, [substAssign(stmt.fields[0]), stmt.fields[1]]);
    }
}

export function unrollForLoops(forstmt) {
    const startValue = evalExpr(forstmt.Initialisation.RHS) | 0;
    let patternInput_1;
    const matchValue_3 = forstmt.Condition;
    if (matchValue_3.tag === 7) {
        patternInput_1 = [evalExpr(matchValue_3.fields[2]), matchValue_3.fields[0]];
    }
    else {
        throw new Exception("Shouldn\'t happen: error check should catch unsupported operators in for loop condition");
    }
    let stepValue;
    const matchValue_4 = forstmt.Step.RHS;
    let matchResult, stepExpr, stepExpr_1;
    if (matchValue_4.tag === 9) {
        switch (matchValue_4.fields[0].tag) {
            case 14: {
                matchResult = 0;
                stepExpr = matchValue_4.fields[2];
                break;
            }
            case 15: {
                matchResult = 1;
                stepExpr_1 = matchValue_4.fields[2];
                break;
            }
            default:
                matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            stepValue = evalExpr(stepExpr);
            break;
        }
        case 1: {
            stepValue = op_UnaryNegation_Int32(evalExpr(stepExpr_1));
            break;
        }
        default:
            throw new Exception("Shouldn\'t happen: error check should catch unsupported step expressions in for loop");
    }
    let iterations;
    const op = patternInput_1[1];
    const step_1 = stepValue;
    const startV_1 = startValue;
    const endV_1 = patternInput_1[0];
    switch (op.tag) {
        case 10: {
            iterations = ~~Math.floor((endV_1 - startV_1) / step_1);
            break;
        }
        case 11: {
            iterations = ~~Math.floor(((endV_1 - startV_1) + 1) / step_1);
            break;
        }
        case 12: {
            iterations = ~~Math.floor((startV_1 - endV_1) / step_1);
            break;
        }
        case 13: {
            iterations = ~~Math.floor(((startV_1 - endV_1) + 1) / step_1);
            break;
        }
        default:
            throw new Exception("Shouldn\'t happen: error check should catch unsupported operators in for loop condition");
    }
    let bodyStatements;
    const matchValue_5 = forstmt.Statement;
    bodyStatements = ((matchValue_5.tag === 2) ? matchValue_5.fields[0] : [matchValue_5]);
    const loopVarName = getPrimaryName(forstmt.Initialisation.LHS.PrimaryType);
    let loopVarWidth;
    const matchValue_6 = forstmt.Initialisation.RHS;
    let matchResult_1, n;
    if (matchValue_6.tag === 13) {
        if (matchValue_6.fields[0].tag === 1) {
            matchResult_1 = 0;
            n = matchValue_6.fields[0].fields[0];
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            loopVarWidth = ((n.tag === 0) ? n.fields[0] : 32);
            break;
        }
        default:
            throw new Exception("Loop variable must be initialized to a constant number");
    }
    return new StatementDU(/* SeqBlock */ 2, [concat_1(initialize(iterations, (k) => {
        const value_1 = (startValue + (k * stepValue)) | 0;
        return map((stmt) => substLoopVar(loopVarName, value_1, loopVarWidth, stmt), bodyStatements);
    })), forstmt.Location]);
}

/**
 * Recursively folds over an ASTNode, calling folder at every level. Only explores parts where there are multiple possibilities within a Node
 */
export function foldAST(folder_mut, state_mut, node_mut) {
    foldAST:
    while (true) {
        const folder = folder_mut, state = state_mut, node = node_mut;
        const state$0027 = folder(state, node);
        switch (node.tag) {
            case 21: {
                folder_mut = folder;
                state_mut = state;
                node_mut = (new ASTNode(/* Module */ 20, [convertModule(node.fields[0].Module)]));
                continue foldAST;
            }
            case 20: {
                folder_mut = folder;
                state_mut = state$0027;
                node_mut = (new ASTNode(/* ModuleItems */ 19, [node.fields[0].ModuleItems]));
                continue foldAST;
            }
            case 19:
                return fold((state_1, node_1) => foldAST(folder, state_1, node_1), state$0027, map((Item) => (new ASTNode(/* Item */ 18, [Item])), node.fields[0].ItemList));
            case 18: {
                folder_mut = folder;
                state_mut = state$0027;
                node_mut = getItem(node.fields[0]);
                continue foldAST;
            }
            case 0: {
                const matchValue = node.fields[0].Range;
                if (matchValue == null) {
                    return state$0027;
                }
                else {
                    folder_mut = folder;
                    state_mut = state$0027;
                    node_mut = (new ASTNode(/* Range */ 16, [matchValue]));
                    continue foldAST;
                }
            }
            case 3: {
                const decl = node.fields[0];
                let tmpState;
                const matchValue_1 = decl.Range;
                tmpState = ((matchValue_1 == null) ? state$0027 : foldAST(folder, state$0027, new ASTNode(/* Range */ 16, [matchValue_1])));
                const matchValue_2 = decl.ArrayRanges;
                if (matchValue_2 == null) {
                    return tmpState;
                }
                else {
                    return fold((state_2, node_2) => foldAST(folder, state_2, node_2), tmpState, map((r_2) => (new ASTNode(/* Range */ 16, [r_2])), matchValue_2));
                }
            }
            case 16: {
                const range = node.fields[0];
                folder_mut = folder;
                state_mut = foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [range.Start]));
                node_mut = (new ASTNode(/* Expression */ 12, [range.End]));
                continue foldAST;
            }
            case 4: {
                folder_mut = folder;
                state_mut = state$0027;
                node_mut = (new ASTNode(/* Statement */ 5, [node.fields[0].Statement]));
                continue foldAST;
            }
            case 5: {
                const stmt = node.fields[0];
                switch (stmt.tag) {
                    case 1: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt.fields[0]]));
                        continue foldAST;
                    }
                    case 2:
                        return fold((state_4, node_4) => foldAST(folder, state_4, node_4), state$0027, map((Item_1) => (new ASTNode(/* Statement */ 5, [Item_1])), stmt.fields[0]));
                    case 3: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Case */ 6, [stmt.fields[0]]));
                        continue foldAST;
                    }
                    case 4: {
                        const elseStmt = stmt.fields[1];
                        const tmpState_1 = foldAST(folder, state$0027, new ASTNode(/* IfStatement */ 8, [stmt.fields[0]]));
                        if (elseStmt != null) {
                            return fold_1((state_5, node_6) => foldAST(folder, state_5, node_6), tmpState_1, singleton(new ASTNode(/* Statement */ 5, [elseStmt])));
                        }
                        else {
                            return tmpState_1;
                        }
                    }
                    case 5: {
                        const forstmt = stmt.fields[0];
                        return fold_1((state_7, node_9) => foldAST(folder, state_7, node_9), fold_1((state_6, node_8) => foldAST(folder, state_6, node_8), foldAST(folder, state$0027, new ASTNode(/* Assignment */ 10, [forstmt.Initialisation])), singleton(new ASTNode(/* Assignment */ 10, [forstmt.Step]))), singleton(new ASTNode(/* Statement */ 5, [unrollForLoops(forstmt)])));
                    }
                    default: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt.fields[0]]));
                        continue foldAST;
                    }
                }
            }
            case 6: {
                const case$_1 = node.fields[0];
                const newState$0027 = fold((state_8, node_10) => foldAST(folder, state_8, node_10), foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [case$_1.Expression])), map((item_2) => (new ASTNode(/* CaseItem */ 7, [item_2])), case$_1.CaseItems));
                const matchValue_3 = case$_1.Default;
                if (matchValue_3 != null) {
                    folder_mut = folder;
                    state_mut = newState$0027;
                    node_mut = (new ASTNode(/* Statement */ 5, [matchValue_3]));
                    continue foldAST;
                }
                else {
                    return newState$0027;
                }
            }
            case 7: {
                const caseItem = node.fields[0];
                folder_mut = folder;
                state_mut = fold((state_9, node_11) => foldAST(folder, state_9, node_11), state$0027, map((expr) => (new ASTNode(/* Number */ 17, [expr])), caseItem.Expressions));
                node_mut = (new ASTNode(/* Statement */ 5, [caseItem.Statement]));
                continue foldAST;
            }
            case 2: {
                folder_mut = folder;
                state_mut = state$0027;
                node_mut = (new ASTNode(/* Assignment */ 10, [node.fields[0].Assignment]));
                continue foldAST;
            }
            case 10: {
                const assign_1 = node.fields[0];
                folder_mut = folder;
                state_mut = foldAST(folder, state$0027, new ASTNode(/* AssignmentLHS */ 11, [assign_1.LHS]));
                node_mut = (new ASTNode(/* Expression */ 12, [assign_1.RHS]));
                continue foldAST;
            }
            case 8: {
                const ifstmt = node.fields[0];
                folder_mut = folder;
                state_mut = foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [ifstmt.Condition]));
                node_mut = (new ASTNode(/* Statement */ 5, [ifstmt.Statement]));
                continue foldAST;
            }
            case 11: {
                const lhs = node.fields[0];
                const matchValue_4 = lhs.VariableBitSelect;
                if (matchValue_4 != null) {
                    folder_mut = folder;
                    state_mut = foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [matchValue_4]));
                    node_mut = (new ASTNode(/* Primary */ 13, [lhs.PrimaryType]));
                    continue foldAST;
                }
                else {
                    folder_mut = folder;
                    state_mut = state$0027;
                    node_mut = (new ASTNode(/* Primary */ 13, [lhs.PrimaryType]));
                    continue foldAST;
                }
            }
            case 12: {
                const expr_2 = node.fields[0];
                let matchResult, unary, e1, e2;
                switch (expr_2.tag) {
                    case 13: {
                        matchResult = 0;
                        unary = expr_2.fields[0];
                        break;
                    }
                    case 14: {
                        matchResult = 1;
                        break;
                    }
                    case 0: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 1: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 2: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 3: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 4: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 5: {
                        matchResult = 2;
                        e1 = expr_2.fields[0];
                        e2 = expr_2.fields[1];
                        break;
                    }
                    case 6: {
                        matchResult = 2;
                        e1 = expr_2.fields[1];
                        e2 = expr_2.fields[2];
                        break;
                    }
                    case 7: {
                        matchResult = 2;
                        e1 = expr_2.fields[1];
                        e2 = expr_2.fields[2];
                        break;
                    }
                    case 8: {
                        matchResult = 2;
                        e1 = expr_2.fields[1];
                        e2 = expr_2.fields[2];
                        break;
                    }
                    case 9: {
                        matchResult = 2;
                        e1 = expr_2.fields[1];
                        e2 = expr_2.fields[2];
                        break;
                    }
                    case 10: {
                        matchResult = 2;
                        e1 = expr_2.fields[1];
                        e2 = expr_2.fields[2];
                        break;
                    }
                    case 11: {
                        matchResult = 3;
                        break;
                    }
                    case 15: {
                        matchResult = 4;
                        break;
                    }
                    default: {
                        matchResult = 0;
                        unary = expr_2.fields[0];
                    }
                }
                switch (matchResult) {
                    case 0: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Unary */ 14, [unary]));
                        continue foldAST;
                    }
                    case 1:
                        return state$0027;
                    case 2: {
                        folder_mut = folder;
                        state_mut = foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [e1]));
                        node_mut = (new ASTNode(/* Expression */ 12, [e2]));
                        continue foldAST;
                    }
                    case 3: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Expression */ 12, [expr_2.fields[1]]));
                        continue foldAST;
                    }
                    default:
                        return fold_1((state_15, node_18) => foldAST(folder, state_15, node_18), fold_1((state_14, node_17) => foldAST(folder, state_14, node_17), foldAST(folder, state$0027, new ASTNode(/* Expression */ 12, [expr_2.fields[0]])), singleton(new ASTNode(/* Expression */ 12, [expr_2.fields[1]]))), singleton(new ASTNode(/* Expression */ 12, [expr_2.fields[2]])));
                }
            }
            case 14: {
                const unary_1 = node.fields[0];
                switch (unary_1.tag) {
                    case 0: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Primary */ 13, [unary_1.fields[0]]));
                        continue foldAST;
                    }
                    case 2: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Expression */ 12, [unary_1.fields[0]]));
                        continue foldAST;
                    }
                    case 4: {
                        folder_mut = folder;
                        state_mut = state$0027;
                        node_mut = (new ASTNode(/* Primary */ 13, [unary_1.fields[0]]));
                        continue foldAST;
                    }
                    default:
                        return state$0027;
                }
            }
            default:
                return state$0027;
        }
        break;
    }
}

export function foldParams(paramMap_mut, node_mut) {
    foldParams:
    while (true) {
        const paramMap = paramMap_mut, node = node_mut;
        let matchValue_3, option_1, matchValue_4, matchValue_5, matchValue_6, matchValue_7, matchValue_8, d, matchValue_12, matchValue_13, matchValue_14, matchValue_15, matchValue_16;
        switch (node.tag) {
            case 13: {
                const pri = node.fields[0];
                const name = getPrimaryName(pri);
                const loc = getPrimaryLocation(pri) | 0;
                const matchValue = tryFind(name, paramMap);
                if (matchValue == null) {
                    return node;
                }
                else {
                    return new ASTNode(/* Number */ 17, [new Number$(/* Unsigned */ 1, [matchValue, loc])]);
                }
            }
            case 12:
                return node;
            case 21: {
                paramMap_mut = paramMap;
                node_mut = (new ASTNode(/* Module */ 20, [convertModule(node.fields[0].Module)]));
                continue foldParams;
            }
            case 20: {
                paramMap_mut = paramMap;
                node_mut = (new ASTNode(/* ModuleItems */ 19, [node.fields[0].ModuleItems]));
                continue foldParams;
            }
            case 19:
                return new ASTNode(/* ModuleItems */ 19, [new ModuleItems(map((item) => {
                    const matchValue_1 = foldParams(paramMap, new ASTNode(/* Item */ 18, [item]));
                    switch (matchValue_1.tag) {
                        case 0:
                            return new ItemDU(/* IOItem */ 0, [matchValue_1.fields[0]]);
                        case 1:
                            return new ItemDU(/* ParamDecl */ 1, [matchValue_1.fields[0]]);
                        case 3:
                            return new ItemDU(/* Decl */ 2, [matchValue_1.fields[0]]);
                        case 2:
                            return new ItemDU(/* ContStatement */ 3, [matchValue_1.fields[0]]);
                        case 4:
                            return new ItemDU(/* AlwaysConstruct */ 4, [matchValue_1.fields[0]]);
                        case 22:
                            return new ItemDU(/* ModuleInstantiation */ 5, [matchValue_1.fields[0]]);
                        default:
                            return toFail(printf("Shouldn\'t happen, expected item"));
                    }
                }, node.fields[0].ItemList))]);
            case 18: {
                paramMap_mut = paramMap;
                node_mut = getItem(node.fields[0]);
                continue foldParams;
            }
            case 4: {
                paramMap_mut = paramMap;
                node_mut = (new ASTNode(/* Statement */ 5, [node.fields[0].Statement]));
                continue foldParams;
            }
            case 5: {
                const stmt = node.fields[0];
                switch (stmt.tag) {
                    case 1: {
                        paramMap_mut = paramMap;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt.fields[0]]));
                        continue foldParams;
                    }
                    case 2:
                        return new ASTNode(/* Statement */ 5, [new StatementDU(/* SeqBlock */ 2, [map((stmt_1) => {
                            const matchValue_2 = foldParams(paramMap, new ASTNode(/* Statement */ 5, [stmt_1]));
                            if (matchValue_2.tag === 5) {
                                return matchValue_2.fields[0];
                            }
                            else {
                                return toFail(printf("Shouldn\'t happen, expected Statement"));
                            }
                        }, stmt.fields[0]), stmt.fields[1]])]);
                    case 3: {
                        paramMap_mut = paramMap;
                        node_mut = (new ASTNode(/* Case */ 6, [stmt.fields[0]]));
                        continue foldParams;
                    }
                    case 4:
                        return new ASTNode(/* Statement */ 5, [new StatementDU(/* Conditional */ 4, [(matchValue_3 = foldParams(paramMap, new ASTNode(/* IfStatement */ 8, [stmt.fields[0]])), (matchValue_3.tag === 8) ? matchValue_3.fields[0] : (() => {
                            throw new Exception("Expected IfStatement");
                        })()), (option_1 = stmt.fields[1], (option_1 != null) ? ((matchValue_4 = foldParams(paramMap, new ASTNode(/* Statement */ 5, [option_1])), (matchValue_4.tag === 5) ? matchValue_4.fields[0] : (() => {
                            throw new Exception("Expected Statement");
                        })())) : undefined), stmt.fields[2]])]);
                    case 5: {
                        const loc_2 = stmt.fields[1] | 0;
                        const forstmt = stmt.fields[0];
                        return new ASTNode(/* Statement */ 5, [new StatementDU(/* ForStatement */ 5, [new ForStatement((matchValue_5 = foldParams(paramMap, new ASTNode(/* Assignment */ 10, [forstmt.Initialisation])), (matchValue_5.tag === 10) ? matchValue_5.fields[0] : (() => {
                            throw new Exception("Expected Assignment");
                        })()), (matchValue_6 = foldParams(paramMap, new ASTNode(/* Expression */ 12, [forstmt.Condition])), (matchValue_6.tag === 12) ? matchValue_6.fields[0] : (() => {
                            throw new Exception("Expected Expression");
                        })()), (matchValue_7 = foldParams(paramMap, new ASTNode(/* Assignment */ 10, [forstmt.Step])), (matchValue_7.tag === 10) ? matchValue_7.fields[0] : (() => {
                            throw new Exception("Expected Assignment");
                        })()), (matchValue_8 = foldParams(paramMap, new ASTNode(/* Statement */ 5, [forstmt.Statement])), (matchValue_8.tag === 5) ? matchValue_8.fields[0] : (() => {
                            throw new Exception("Expected Statement");
                        })()), loc_2), loc_2])]);
                    }
                    default: {
                        paramMap_mut = paramMap;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt.fields[0]]));
                        continue foldParams;
                    }
                }
            }
            case 6: {
                const case$_1 = node.fields[0];
                let caseExpr;
                const matchValue_9 = foldParams(paramMap, new ASTNode(/* Expression */ 12, [case$_1.Expression]));
                if (matchValue_9.tag === 12) {
                    caseExpr = matchValue_9.fields[0];
                }
                else {
                    throw new Exception("Expected Expression");
                }
                const caseItems = map((item_2) => {
                    const matchValue_10 = foldParams(paramMap, new ASTNode(/* CaseItem */ 7, [item_2]));
                    if (matchValue_10.tag === 7) {
                        return matchValue_10.fields[0];
                    }
                    else {
                        return toFail(printf("Expected caseitem"));
                    }
                }, case$_1.CaseItems);
                let caseDefault;
                const matchValue_11 = case$_1.Default;
                caseDefault = ((matchValue_11 != null) ? foldParams(paramMap, new ASTNode(/* Statement */ 5, [matchValue_11])) : undefined);
                return new ASTNode(/* Case */ 6, [(caseDefault != null) ? ((caseDefault.tag === 5) ? ((d = caseDefault.fields[0], new CaseStatement(caseExpr, caseItems, d, case$_1.Location))) : toFail(printf("Expected stmt"))) : toFail(printf("Expected stmt"))]);
            }
            case 7: {
                const caseItem = node.fields[0];
                return new ASTNode(/* CaseItem */ 7, [new CaseItem(caseItem.Expressions, (matchValue_12 = foldParams(paramMap, new ASTNode(/* Statement */ 5, [caseItem.Statement])), (matchValue_12.tag === 5) ? matchValue_12.fields[0] : toFail(printf("Shouldn\'t happen, expected Statement"))))]);
            }
            case 2: {
                paramMap_mut = paramMap;
                node_mut = (new ASTNode(/* Assignment */ 10, [node.fields[0].Assignment]));
                continue foldParams;
            }
            case 10: {
                const assign_1 = node.fields[0];
                return new ASTNode(/* Assignment */ 10, [new Assignment(assign_1.Type, (matchValue_13 = foldParams(paramMap, new ASTNode(/* AssignmentLHS */ 11, [assign_1.LHS])), (matchValue_13.tag === 11) ? matchValue_13.fields[0] : (() => {
                    throw new Exception("Expected AssignmentLHS");
                })()), (matchValue_14 = foldParams(paramMap, new ASTNode(/* Expression */ 12, [assign_1.RHS])), (matchValue_14.tag === 12) ? matchValue_14.fields[0] : (() => {
                    throw new Exception("Expected Expression");
                })()))]);
            }
            case 8: {
                const ifstmt = node.fields[0];
                return new ASTNode(/* IfStatement */ 8, [new IfStatement((matchValue_15 = foldParams(paramMap, new ASTNode(/* Expression */ 12, [ifstmt.Condition])), (matchValue_15.tag === 12) ? matchValue_15.fields[0] : (() => {
                    throw new Exception("Expected Expression");
                })()), (matchValue_16 = foldParams(paramMap, new ASTNode(/* Statement */ 5, [ifstmt.Statement])), (matchValue_16.tag === 5) ? matchValue_16.fields[0] : (() => {
                    throw new Exception("Expected Statement");
                })()), ifstmt.Location)]);
            }
            case 11: {
                const matchValue_17 = node.fields[0].VariableBitSelect;
                if (matchValue_17 != null) {
                    paramMap_mut = paramMap;
                    node_mut = (new ASTNode(/* Expression */ 12, [matchValue_17]));
                    continue foldParams;
                }
                else {
                    return node;
                }
            }
            default:
                return node;
        }
        break;
    }
}

/**
 * get rhs expressions from always, continuous assign, case stmt... (all of them)
 */
export function getAllExpressions$0027(expressions, node) {
    if (node.tag === 12) {
        return append_1(expressions, singleton(node.fields[0]));
    }
    else {
        return expressions;
    }
}

export function getNumbers(numbers, node) {
    if (node.tag === 17) {
        return append_1(numbers, singleton(node.fields[0]));
    }
    else {
        return numbers;
    }
}

export function getAssignments$0027(assignments, node) {
    if (node.tag === 10) {
        return append_1(assignments, singleton(node.fields[0]));
    }
    else {
        return assignments;
    }
}

export function getContAssignments(assignments, node) {
    if (node.tag === 2) {
        return append_1(assignments, singleton(node.fields[0].Assignment));
    }
    else {
        return assignments;
    }
}

export function getAlwaysAssignments(assignments, node) {
    if (node.tag === 5) {
        const stmt = node.fields[0];
        switch (stmt.tag) {
            case 1:
                return append_1(assignments, singleton(stmt.fields[0]));
            case 0:
                return append_1(assignments, singleton(stmt.fields[0]));
            default:
                return assignments;
        }
    }
    else {
        return assignments;
    }
}

export function assignmentLocation(a) {
    const matchValue = a.LHS.PrimaryType;
    switch (matchValue.tag) {
        case 1:
            return matchValue.fields[0].Location | 0;
        case 2:
            return matchValue.fields[0].Location | 0;
        case 3:
            return matchValue.fields[0].Location | 0;
        case 4:
            return matchValue.fields[0].Location | 0;
        case 5:
            return matchValue.fields[0].Location | 0;
        case 6:
            return matchValue.fields[0].Location | 0;
        default:
            return matchValue.fields[0].Location | 0;
    }
}

export function getAssignmentsWithLocations(assignments, node) {
    switch (node.tag) {
        case 19:
            return append_1(assignments, choose((_arg) => {
                if (_arg.tag === 3) {
                    const c = _arg.fields[0];
                    return [c.Assignment, c.Location];
                }
                else {
                    return undefined;
                }
            }, ofArray(node.fields[0].ItemList)));
        case 5: {
            const stmt = node.fields[0];
            switch (stmt.tag) {
                case 1: {
                    const a = stmt.fields[0];
                    return append_1(assignments, singleton([a, assignmentLocation(a)]));
                }
                case 0: {
                    const a_1 = stmt.fields[0];
                    return append_1(assignments, singleton([a_1, assignmentLocation(a_1)]));
                }
                case 5: {
                    const forstmt = stmt.fields[0];
                    return append_1(assignments, ofArray([[forstmt.Initialisation, assignmentLocation(forstmt.Initialisation)], [forstmt.Step, assignmentLocation(forstmt.Step)]]));
                }
                default:
                    return assignments;
            }
        }
        default:
            return assignments;
    }
}

export function getAlwaysBlocks(alwaysBlocks, node) {
    if (node.tag === 4) {
        return append_1(alwaysBlocks, singleton(node.fields[0]));
    }
    else {
        return alwaysBlocks;
    }
}

export function getBlockingAssignmentsWithLocation(assignments, node) {
    if (node.tag === 5) {
        const stmt = node.fields[0];
        if (stmt.tag === 1) {
            return append_1(assignments, singleton([stmt.fields[0], stmt.fields[1]]));
        }
        else {
            return assignments;
        }
    }
    else {
        return assignments;
    }
}

export function getNonBlockingAssignmentsWithLocation(assignments, node) {
    if (node.tag === 5) {
        const stmt = node.fields[0];
        if (stmt.tag === 0) {
            return append_1(assignments, singleton([stmt.fields[0], stmt.fields[1]]));
        }
        else {
            return assignments;
        }
    }
    else {
        return assignments;
    }
}

export function getBlockingAssignments(assignments, node) {
    if (node.tag === 5) {
        const stmt = node.fields[0];
        if (stmt.tag === 1) {
            return append_1(assignments, singleton(stmt.fields[0]));
        }
        else {
            return assignments;
        }
    }
    else {
        return assignments;
    }
}

export function getNonBlockingAssignments(assignments, node) {
    if (node.tag === 5) {
        const stmt = node.fields[0];
        if (stmt.tag === 0) {
            return append_1(assignments, singleton(stmt.fields[0]));
        }
        else {
            return assignments;
        }
    }
    else {
        return assignments;
    }
}

